import React, { useEffect } from "react";
import { Empty, Spin } from "antd";
import styles from "@aspen/theme/Venture.module.less";
import { i18nUtil, VENTURES_TAB_ACTION } from "@aspen/libs";
import VentureItem from "./VentureItem/VentureItem";
import { useFetchVentureList } from "@aspen/hooks";
import { WithKYCInfo } from "@aspen/ui";
import type { IInjectProps, TKycLevelNumber } from "@aspen/model";
import { withRouter } from "next/router";
import type { TCoverType } from "@adgm/cross-models";

interface IProps extends IInjectProps {
  showGuideModal: (
    level: TKycLevelNumber,
    noClose?: boolean,
    coverType?: TCoverType,
    onClose?: () => void,
  ) => boolean;
}

const PrimaryView: React.FC = (props: IProps) => {
  const { showGuideModal, router } = props;
  useEffect(() => {
    showGuideModal(2, false, "view", router.back);
  }, []);

  const intl = i18nUtil.t();

  const { data: ventureListData, isLoading } = useFetchVentureList({ limit: 100, shares: 0 });

  return (
    <Spin spinning={isLoading}>
      <div className={styles.venture} style={{ marginTop: "34px" }}>
        {ventureListData && ventureListData.length > 0 ? (
          <div className={styles.ventureList}>
            {ventureListData.map((item, index) => (
              <div className={styles.ventureListItem} key={index}>
                <VentureItem key={item.id} data={item} tabName={VENTURES_TAB_ACTION.primary} />
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.ventureEmpty}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={intl["empty.list"]} />
          </div>
        )}
      </div>
    </Spin>
  );
};
export const Primary = React.memo(WithKYCInfo(withRouter(PrimaryView)));
